export default __webpack_public_path__ + "959eff7fdaad371b5121c7a927225280.svg";